<div class="row">
    @for (field of controls | keyvalue : this.keyvaluePipeCompareFn; track field) {
    <div class="align-self-top" [class]="$any(field).value.size?.toClass() || 'col-12 p-0'">
        <lib-form-input [field]="field.value" [name]="field.key" [form]="form" [filter]="filter"></lib-form-input>
    </div>
    }
</div>
